import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Immediato', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-93" data-mp="9lbhb4dgrhf6">
      <div className="mx-auto max-w-4xl text-center" data-id="element-94" data-mp="4m8nyh6uizn1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-95" data-mp="4njpsbgqdxbi">
          Pianifica un Intero Anno di Lezioni di Danza in soli{' '}
          <span className="italic text-brand" data-id="element-96" data-mp="nbez9j5b8oyt">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-97" data-mp="3d1sakxd0hjt4">
          Unisciti a oltre 1.500 insegnanti di danza che hanno smesso di
          improvvisare. Entra in sala con tutto pronto per insegnare, emozionare
          e ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-98" data-mp="3e961dp7ffzfz">
          <img src="https://cdn.magicpatterns.com/uploads/sT8QuN2WpVeLdVaKsUdP96/db67b77f-49e8-47cf-ad22-daf8edea4d76.webp" alt="Il bundle DANCE PRONTA: sei volumi da La Scintilla Creativa all'Eccellenza Professionale, la piattaforma digitale su desktop, tablet e telefono, e i 5 bonus inclusi" className="mx-auto w-[78%] max-w-lg sm:w-[72%]" data-id="element-99" data-mp="35audhuxy3fr8" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl text-sm leading-relaxed text-ink/55 sm:text-base" data-id="element-100" data-mp="s21hi9lxc9yx">
          <span className="font-bold text-ink" data-id="element-101" data-mp="ia5i8v83qdt4">Il Bundle DANCE PRONTA™:</span> 6
          volumi dai 4 anni al livello professionale, più il Kit Coreografia e 5
          bonus strategici.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6" data-id="element-102" data-mp="1ayjhtfeu9i6s">
          <CtaButton href="#offer" data-id="element-103" data-mp="x1eevoaf8zfr" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-104" data-mp="x0crckc7ykh5">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-105" data-mp="3hr3qlsftw548" data-mpi={index}>
                <span data-id="element-106" data-mp="1x9b5n20k33d3">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-107" data-mp="1x7hw9eyk651e">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}